module.exports = __webpack_public_path__ + "static/media/referralPhoneBanner.b7f894b2.png";